/**
 * @flow
 * @relayHash 8908e326f8555e5540993f67d6c0d12d
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SendPushNotificationMutationVariables = {|
  input: {
    title: string;
    payload?: ?string;
    entityId?: ?string;
    entityType?: ?"activity" | "job" | "job_offer" | "job_request" | "other";
    target?: ?"all_students" | "all_tutors" | "student" | "tutor";
    targetUser?: ?number;
    clientMutationId?: ?string;
  };
|};
export type SendPushNotificationMutationResponse = {|
  +sendPushNotification: ?{|
    +clientMutationId: ?string;
  |};
|};
*/

/*
mutation SendPushNotificationMutation(
  $input: SendPushNotificationMutationInput!
) {
  sendPushNotification(input: $input) {
    clientMutationId
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  fragment: {
    argumentDefinitions: [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'SendPushNotificationMutationInput!',
        defaultValue: null,
      },
    ],
    kind: 'Fragment',
    metadata: null,
    name: 'SendPushNotificationMutation',
    selections: [
      {
        kind: 'LinkedField',
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input',
            type: 'SendPushNotificationMutationInput!',
          },
        ],
        concreteType: 'SendPushNotificationMutationPayload',
        name: 'sendPushNotification',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            args: null,
            name: 'clientMutationId',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ],
    type: 'Mutations',
  },
  id: null,
  kind: 'Batch',
  metadata: {},
  name: 'SendPushNotificationMutation',
  query: {
    argumentDefinitions: [
      {
        kind: 'LocalArgument',
        name: 'input',
        type: 'SendPushNotificationMutationInput!',
        defaultValue: null,
      },
    ],
    kind: 'Root',
    name: 'SendPushNotificationMutation',
    operation: 'mutation',
    selections: [
      {
        kind: 'LinkedField',
        alias: null,
        args: [
          {
            kind: 'Variable',
            name: 'input',
            variableName: 'input',
            type: 'SendPushNotificationMutationInput!',
          },
        ],
        concreteType: 'SendPushNotificationMutationPayload',
        name: 'sendPushNotification',
        plural: false,
        selections: [
          {
            kind: 'ScalarField',
            alias: null,
            args: null,
            name: 'clientMutationId',
            storageKey: null,
          },
        ],
        storageKey: null,
      },
    ],
  },
  text:
    'mutation SendPushNotificationMutation(\n  $input: SendPushNotificationMutationInput!\n) {\n  sendPushNotification(input: $input) {\n    clientMutationId\n  }\n}\n',
};

module.exports = batch;



// WEBPACK FOOTER //
// ./src/mutations/__generated__/SendPushNotificationMutation.graphql.js